import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M5.64 5.632a9 9 0 1 0 6.36 -2.632v7.714","key":"svg-0"}]]

const IconBrandGravatar = createReactComponent('outline', 'brand-gravatar', 'BrandGravatar', __iconNode);

export default IconBrandGravatar;